export const HeaderSection = {
  partners: 'Partners',
  accessories: 'Accessories',
  stages: 'Stages',
  order: 'Order',
};

export const description = "A smart home is your personal assistant who cares about your comfort and coziness. The system can be installed anywhere you live or work. To control it, a tablet, phone or computer is enough. Using its unique secure protocol and mobile application, the complex guarantees you full control over your premises at any time. In order to turn on the light, open the curtains or turn off the air conditioner - it is not necessary to get up from the sofa."